import { Inject, Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import { map } from 'rxjs/operators';
import {GeneralService, StorageService} from "front-common-toolkits";
@Injectable({
  providedIn: 'root'
})
export class TenantUserService extends GeneralService {
  serviceName = 'TenantUserService';

  constructor(
    public http: HttpClient,
    private storageService: StorageService,
    @Inject('httpBaseSettings') public httpBaseSettings: any
  ) {
    super(http,httpBaseSettings);

    this.setModelPath('/ten/user');
  }

  getCurrentUserInfo() {
    return this.http.get(this.httpBase + '/ten/auth/user')
  } 
  importTenUserData(params: any) {
    let api = this.httpBase + '/ten/user/importTenUserData'
    var data = params
    return this.http.post(api, data, { reportProgress: true, })
  }
  getById(userId:number){
    return this.http.get(`${this.httpBase}/ten/user/${userId}`).pipe(map(res => res['data']));
  }
}
